import RoomServiceMenuItemsData from "../../components/hotel/datamanagement/RoomServiceMenuItemsData";

export default function RoomServicePage() {
  return <RoomServiceMenuItemsData />;
}

